
import { Placement } from '@post-office/placements-frontend/operations-overview-discoverability-spotlights';
export default Placement;
